// extracted by mini-css-extract-plugin
module.exports =  {"row":"RowLargeCellActions-module__row___nO1qC","tc-list-actions":"RowLargeCellActions-module__tc-list-actions___uHWmv"};